import React, { useState } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment-v1'
import CircularProgress from '@material-ui/core/CircularProgress'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../../../Components/GenericFlatButton'

const ManualEndDateChangeModal = ({ onSubmit, onCancel, classes }) => {
  const [endDate, setEndDate] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const minDate = moment().add(1, 'day')

  const handleSubmit = async () => {
    if (!endDate) return
    setIsLoading(true)
    await onSubmit(endDate.format('YYYY-MM-DD'))
    setIsLoading(false)
  }

  return (
    <div className={classes.container}>
      {isLoading && (
        <div className={classes.loaderContainer}>
          <CircularProgress size={20} />
        </div>
      )}
      <div className={classes.title}>Manual end date change</div>
      <div className={classes.description}>
        Select new end date and press UPDATE to apply it to the LATEST user
        contract. Do it for EXTENDING CONTRACT A BIT AND PROCEED THEN WITH A
        REGULAR FLOW and ONLY IF THERE IS NO OTHER OPTIONS to extend user
        contract.
      </div>
      <div className={classes.bodyContainer}>
        <div className={classes.selectTitle}>New end date:</div>
        <div className={classes.datePicker}>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDatePicker
              disableToolbar
              inputProps={{ readOnly: true }}
              minDate={minDate}
              helperText={null}
              variant="dialog"
              format="DD-MM-YYYY"
              margin="normal"
              id="date-picker-inline"
              value={endDate}
              onChange={date => setEndDate(date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={classes.inputRoot}
              placeholder="Select date"
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      {!isLoading && (
        <div className={classes.buttonContainer}>
          <GenericFlatButton
            type="outline"
            title="Cancel"
            onClick={onCancel}
            customStyles={classes.cancelButton}
          />
          <GenericFlatButton
            type="filled"
            title="Update"
            onClick={handleSubmit}
            disabled={!endDate}
            customStyles={classes.submitButton}
          />
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(ManualEndDateChangeModal)
